interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const shareOptions = [
  { icon: 'ri-wechat-line', label: '微信', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-weibo-line', label: '微博', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-qq-line', label: 'QQ', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-link', label: '复制链接', color: 'bg-background-200 text-foreground-700' },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  if (!open) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      // clipboard not available
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4 animate-fade-in" onClick={onClose}>
      <div
        className="w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-5 animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-950">分享《{title}》</h3>
          <button onClick={onClose} className="flex h-8 w-8 items-center justify-center rounded-full text-foreground-500 hover:bg-background-100">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {shareOptions.map((opt) => (
            <button
              key={opt.label}
              onClick={opt.label === '复制链接' ? copyLink : onClose}
              className="flex flex-col items-center gap-2 whitespace-nowrap"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-full ${opt.color}`}>
                <i className={`${opt.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-600">{opt.label}</span>
            </button>
          ))}
        </div>
        <p className="mt-4 rounded-md bg-background-100 p-3 text-center text-xs text-foreground-500">
          分享功能为演示效果，实际不会跳转到社交平台
        </p>
      </div>
    </div>
  );
}